export const DEFAULT_DOCUMENT_PASSWORD_BODY =
  "<p>The password to open the attached documents is: {{pdfPassword}}</p><p>Please keep this password confidential.</p>";

function debitNoteReceiptPaymentStatuses() {
  return process.env.REACT_APP_DEBIT_NOTE_ALLOW_PRINT_RECEIPT
    ? process.env.REACT_APP_DEBIT_NOTE_ALLOW_PRINT_RECEIPT.split(",").map((s) =>
        s.trim()
      )
    : ["PAID", "SETTLED", "EXP", "DIRECT", "MATCHING", "PARTIAL"];
}

export const ENTITY_DOCUMENT_EMAIL = {
  debitNote: {
    entity: "debitNote",
    apiKey: "DebitNote",
    title: "Send Debit Note Email",
    templateType: "DEBIT_NOTE",
    passwordTemplateType: "DEBIT_NOTE_PASSWORD",
    selectableKeys: ["debitNote", "debitNoteReceipt"],
    defaultKeys: ["debitNote"],
    defaultSubject: "Debit Note {{code}} for {{clientName}}",
    defaultBody:
      "<p>Dear {{contactPerson}},</p><p>Please find attached the Debit Note {{code}} for {{clientName}}.</p><p>Kind regards,<br/>{{consultantName}}<br/>{{companyName}}</p>",
    defaultPasswordSubject: "Password for Debit Note {{code}}",
    defaultPasswordBody: DEFAULT_DOCUMENT_PASSWORD_BODY,
    sendingTitle: "Sending Debit Note…",
    sendingMessage: "Generating the PDF and sending the email.",
    sentTitle: "Debit Note sent",
    sentWithPassword: "The PDF and a separate password email were sent.",
    sentPlain: "The Debit Note PDF was emailed to the client.",
    emptyLog: "No Debit Note emails have been sent for this record.",
    attachHint: "Choose which PDFs to generate and attach.",
  },
  quotation: {
    entity: "quotation",
    apiKey: "Quotation",
    title: "Send Quotation Email",
    templateType: "QUOTATION",
    passwordTemplateType: "QUOTATION_PASSWORD",
    selectableKeys: ["quotation", "quotationConfirmation"],
    defaultKeys: ["quotation"],
    defaultSubject: "Quotation {{code}} for {{clientName}}",
    defaultBody:
      "<p>Dear {{contactPerson}},</p><p>Please find attached the Quotation {{code}} for {{clientName}}.</p><p>Kind regards,<br/>{{consultantName}}<br/>{{companyName}}</p>",
    defaultPasswordSubject: "Password for Quotation {{code}}",
    defaultPasswordBody: DEFAULT_DOCUMENT_PASSWORD_BODY,
    sendingTitle: "Sending Quotation…",
    sendingMessage: "Generating the PDF and sending the email.",
    sentTitle: "Quotation sent",
    sentWithPassword: "The PDF and a separate password email were sent.",
    sentPlain: "The Quotation PDF was emailed to the client.",
    emptyLog: "No Quotation emails have been sent for this record.",
    attachHint: "Choose which PDFs to generate and attach.",
  },
  renewal: {
    entity: "renewal",
    apiKey: "Renewal",
    title: "Send Renewal Email",
    templateType: "RENEWAL",
    passwordTemplateType: "RENEWAL_PASSWORD",
    selectableKeys: ["renewalNotice", "renewalCancelNotice"],
    defaultKeys: ["renewalNotice"],
    defaultSubject: "Renewal Notice {{code}} for {{clientName}}",
    defaultBody:
      "<p>Dear {{contactPerson}},</p><p>Please find attached the Renewal Notice {{code}} for {{clientName}}.</p><p>Kind regards,<br/>{{consultantName}}<br/>{{companyName}}</p>",
    defaultPasswordSubject: "Password for Renewal Notice {{code}}",
    defaultPasswordBody: DEFAULT_DOCUMENT_PASSWORD_BODY,
    sendingTitle: "Sending Renewal Notice…",
    sendingMessage: "Generating the PDF and sending the email.",
    sentTitle: "Renewal Notice sent",
    sentWithPassword: "The PDF and a separate password email were sent.",
    sentPlain: "The Renewal Notice PDF was emailed to the client.",
    emptyLog: "No Renewal emails have been sent for this record.",
    attachHint: "Choose which PDFs to generate and attach.",
  },
};

export function isOptionalDocumentAllowed(entity, values, key) {
  if (entity === "debitNote" && key === "debitNoteReceipt") {
    return debitNoteReceiptPaymentStatuses().includes(
      String(values?.paymentStatus || "")
    );
  }
  if (entity === "renewal" && key === "renewalCancelNotice") {
    return String(values?.status || "") === "TERMINATE";
  }
  return true;
}

export function getEntityDocumentEmailConfig(entity) {
  return ENTITY_DOCUMENT_EMAIL[entity] || null;
}
